import React, { useEffect, useState } from "react";
import api from "../../api"
import "./Intent.css"; // Custom CSS file for styling
import { Container, Form, Row, Col, Accordion } from "react-bootstrap";
import { Link } from "react-router-dom";
import arrow_btn from "../../assets/images/icon/arrow-btn.svg";

const IntentsView = () => {
  const [intents, setIntents] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    // Fetch intents from the API
    const fetchIntents = async () => {
      try {
        const response = await api.get(
          `${process.env.REACT_APP_API_URL}/admin/bot/fetch-intent`
        );
        setIntents(response.data.intents);
        setLoading(false);
      } catch (err) {
        setError("Failed to load intents. Please try again later.");
        setLoading(false);
      }
    };

    fetchIntents();
  }, []);

  if (loading) return <div className="loading">Loading...</div>;
  if (error) return <div className="error">{error}</div>;

  return (
    <div className="pending-list-page feedbacks">
      <div className="tab-content" id="pills-tabContent">
        <div className="joblist-container create-vacancy main-pages-s">
          <Row className="mb-2 align-items-center">
            <Col lg="6" md="6" className="Joblist-column">
              <Link to="/bot-dashboard">
                <h5 className="text-uppercase heading-one">
                  <img src={arrow_btn} alt="arrow_btn" />
                  Intents
                </h5>
              </Link>
            </Col>
          </Row>

          <div className="intents-container">
            <div className="tabel-application table-responsive">
              <div className="timeto-hire-card userlist">
                <div className="table-custome-class range-custome">
                  <div className="scroll-container">
                    <div className="table-pending-list">
                      <div className="table-wrapper  profile-table">
                        <div className="react-bootstrap-table">
                          <table className="intents-table">
                            <thead>
                              <tr>
                                <th>Tag</th>
                                <th>Patterns</th>
                                <th>Responses</th>
                              </tr>
                            </thead>
                            <tbody>
                              {intents.map((intent, index) => (
                                <tr key={index}>
                                  <td className="text-capitalize">
                                    <b>{intent.tag}</b>
                                  </td>
                                  <td>
                                    <ul>
                                      {intent.patterns.map((pattern, idx) => (
                                        <li key={idx}>{pattern}</li>
                                      ))}
                                    </ul>
                                  </td>
                                  <td>
                                    <ul>
                                      {intent.responses.map((response, idx) => (
                                        <li key={idx}>{response}</li>
                                      ))}
                                    </ul>
                                  </td>
                                </tr>
                              ))}
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default IntentsView;
